var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BaseTable", {
    staticClass: "custom-table",
    attrs: { tableClass: "table-bordered", hidePagination: "" },
    scopedSlots: _vm._u([
      {
        key: "thead",
        fn: function() {
          return [
            _c("thead", [
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$t("apps.billing.label.detail")))]),
                _vm._v(" "),
                _c("th", { staticClass: "text-right" }, [
                  _vm._v(_vm._s(_vm.$t("apps.billing.label.payamount")))
                ])
              ])
            ])
          ]
        },
        proxy: true
      },
      {
        key: "tbody",
        fn: function() {
          return [
            _c("tbody", [
              _c("tr", [
                _c("td", [
                  _vm._v("\n          " + _vm._s(_vm.detail) + "\n        ")
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-right" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.getCurrencyWithNumber(
                          _vm.numberel(_vm.totalNumber, "0,0.[00]")
                        )
                      ) +
                      "\n        "
                  )
                ])
              ])
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-444fbd12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-444fbd12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/paymentpackage/InvoiceListTable.vue
// module id = null
// module chunks = 